import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import ResultTable from "../../../components/table/ResultTable";
import EmptyLine from "../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B13({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FW05.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the flow rates between 100yr and FW profiles at the following flow change locations. These differences are highlighted in the following table.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.filter(r => r.yr100?.toString() !== r.fw?.toString()).map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell></ResultHeaderCell>
                            <ResultHeaderCell colSpan={2}>Flow Rate (cfs)</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>100yr</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>FW</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            (row.data || [{}]).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.yr100}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r.yr100, r.fw)}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.FW06.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the boundary conditions between 100yr and FW profiles. These differences are highlighted in the following table.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell colSpan={2}>Boundary Condition</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(25)}}>100yr</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(25)}}>FW</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                (row.data || [{}]).map(r => {
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{textAlign: 'left'}}>
                                                {r.YR100.dn_text}
                                                {' '}={' '}
                                                {r.YR100.dn_value}
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'left'}}>
                                                {ResultCellHighlight(r.YR100.dn_text, r.FW.dn_text)}
                                                {' '}={' '}
                                                {ResultCellHighlight(r.YR100.dn_value, r.FW.dn_value)}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.FW04.error_id: {
            return (
                <>
                    <ResultText>
                        Flow consistency could not be checked since either 100yr or FW profiles are not available or labeled in the plan.
                    </ResultText>
                </>
            )
        }
    }
}